export class SubscriptionCounter {
  public static counter = 0;
}
